<template>
  <div :class='"pageNav"+ " " + customClass'>
    <div :class="{ 'bg-white': bgClass == 'lightblue' }">
      <div
        class='pageNav__ctas d-flex justify-content-between flex-column align-items-center text-center position-relative'
        :class="{ 'lightaccent-bg': bgClass == 'lightaccent', 'lightblue-bg': bgClass == 'lightblue', 'single-item': menus.length == 1 }">
        <div v-for='(item, itemIndex) in menus' :key='itemIndex' :class="'cta-'+itemIndex">
          <p class='fw-extrabold text-center' v-html="item.title"></p>
          <button @click.prevent='goToPage(item.routerLinkName)' class='header__button def-btn text-nowrap'>
            {{ item.ctaText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNav',
  props: {
    menus: {
      type: Array,
      required: true
    },
    bgClass: {
      type: String,
      // required: true,
      default: 'lightblue'
    },
    customClass: ""
  },
  methods: {
    goToPage (name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>
